import React from 'react'
import ProgramCard from '../components/ProgramCard'
import { EmptyState, Spinner } from '@blend-ed/blendx-ui'
import { FormattedMessage } from '@edx/frontend-platform/i18n';
import messages from './messages';

function ProgramTab({ renderPrograms, isLoading }) {

    if (isLoading) {
        return (
            <div className="blendx-spinner-container">
                <Spinner animation="border" size="lg" variant="dark" />
            </div>
        )
    }

    if (!renderPrograms.length) {
        return <EmptyState
            type="box"
            message={<FormattedMessage {...messages.noProgramsFound} />}
            className="program-empty-state"
        />
    }

    return (
        <div className="program-cards-container">
            {renderPrograms.map((program, index) => (
                <ProgramCard key={program.program?.id} title={program.program?.name} description={program.program?.description} image={program.program?.image} estimatedTime={program.program?.duration} courseCount={program.program?.programCourses?.length} link={`/learning/learner-program/${program.program?.id}`} durationMetric={program.program?.durationMetric} />
            ))}
        </div>
    )
}

export default ProgramTab
